import { render, staticRenderFns } from "./ArticleEdit.vue?vue&type=template&id=bd1aae8e&scoped=true&"
import script from "./ArticleEdit.vue?vue&type=script&lang=js&"
export * from "./ArticleEdit.vue?vue&type=script&lang=js&"
import style0 from "./ArticleEdit.vue?vue&type=style&index=0&id=bd1aae8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1aae8e",
  null
  
)

export default component.exports